import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "component-top"
}
const _hoisted_3 = { class: "component-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id.toString(),
    style: _normalizeStyle('min-width:250px; min-height:150px; flex:' + _ctx.componentState.flex),
    class: "layout-component"
  }, [
    (!_ctx.stacked && false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.componentName), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
        id: _ctx.id,
        componentState: _ctx.componentState
      }, null, 8, ["id", "componentState"]))
    ])
  ], 12, _hoisted_1))
}